import { Formik } from 'formik'
import React from 'react'
import _ from 'lodash'

import Field from '../../views/widgets/Field'
import InputText from '../../views/widgets/InputText'
import InputTextTagSuggestion from '../general-info/InputTextTagSuggestion'
import InputTags from '../../views/widgets/InputTags'
import InputTextarea from '../../views/widgets/InputTextarea'
import InputCheckbox from '../../views/widgets/InputCheckbox'
import CheckboxGroup from '../../views/widgets/CheckboxGroup'
import ListingPortalContainer from '../listing-portal/ListingPortalContainer'
import ListingImage from './ListingImage'
import ListingActionPanel from './ListingActionPanel'

const ListingForm = ({
  language = 'th',
  initialValues,
  onValidate,
  onSubmit,
  onDelete,
  isEditing,
}) => (
  <Formik
    enableReinitialize={true}
    validateOnChange={true}
    isInitialValid={false}
    initialValues={initialValues}
    validate={onValidate}
    onSubmit={onSubmit}
  >
    {({
      values,
      errors,
      handleBlur,
      handleChange,
      handleSubmit,
      setValues,
      setFieldValue,
    }) => (
      <React.Fragment>
        <ListingActionPanel
          listingID={values._id}
          onDelete={onDelete}
          onSubmit={handleSubmit}
          isEditing={isEditing}
        />
        <Field label={`รูปภาพ`}>
          <ListingImage
            key={values.mainImageLastChecked}
            mainImageId={values.mainImageId}
            mainImageLastChecked={values.mainImageLastChecked}
          />
        </Field>
        <Field label={`ชื่อ[${language}]`}>
          <InputText
            name={`title.${language}`}
            placeholder="ชื่อประเภท/หมวดหมู่ของข้อมูล"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.title[language]}
            error={errors.title && errors.title[language]}
          />
        </Field>
        <Field label={`แท็ก[${language}]`}>
          <InputTags
            name={`tags.${language}`}
            placeholder="ใส่แท็กที่น่าสนใจของคุณ (แท็กควรสอดคล้องกับพอทัล )"
            onChange={value => {
              setFieldValue(`tags.${language}`, value)
            }}
            values={values.tags[language]}
            error={errors.tags && errors.tags[language]}
            renderInputText={InputTextTagSuggestion}
          />
        </Field>
        <Field label={`รายละเอียด[${language}]`}>
          <InputTextarea
            name={`description.${language}`}
            placeholder="อธิบายรายละเอียดประเภท/หมวดหมู่ของข้อมูล (ถ้ามี)"
            onChange={handleChange}
            value={_.get(values, `description.${language}`)}
          />
        </Field>
        <Field label={`โปรไฟล์`}>
          <CheckboxGroup
            name="profiles"
            values={values.profiles}
            onChange={values => setFieldValue('profiles', values)}
          >
            <InputCheckbox id="default" value="default" name="default" />
            <InputCheckbox id="youngster" value="youngster" name="youngster" />
            <InputCheckbox id="traveller" value="traveller" name="traveller" />
          </CheckboxGroup>
        </Field>
        <Field label={`ใช้ใน website`}>
          <div class="control">
            <label class="radio">
              <input
                type="radio"
                name="isUseInWeb"
                checked={values.isUseInWeb}
                onChange={e => {
                  setFieldValue(`isUseInWeb`, true)
                }}
              />
              Yes
            </label>
            <label class="radio">
              <input
                type="radio"
                name="isUseInWeb"
                checked={!values.isUseInWeb}
                value={values.isUseInWeb}
                onChange={e => {
                  setFieldValue(`isUseInWeb`, false)
                }}
              />
              No
            </label>
          </div>
        </Field>
        <Field label={`โน้ตภายใน`}>
          <InputTextarea
            name={`internalRemark`}
            placeholder="Enter your internal remark"
            onChange={handleChange}
            value={values.internalRemark}
          />
        </Field>
        <Field label={`พอทัล[${language}]`}>
          <ListingPortalContainer
            portals={values.portals}
            onValueChange={values => setFieldValue('portals', values)}
          />
        </Field>
      </React.Fragment>
    )}
  </Formik>
)

export default ListingForm



// WEBPACK FOOTER //
// ./src/components/templates/listing-detail/ListingForm.js